module.exports = __webpack_public_path__ + "img/baby_unknowns.adc10fbd.png";